import React from "react";
import PrintContractDetails from "./PrintContractDetails";
import PrintOffHireDetails from "./PrintOffHireDetails";
import PrintInsuranceDetails from "./PrintInsuranceDetails";
import PrintTermsAcknowledgement from "./PrintTermsAcknowledgement";
import PrintDVHTermsConditions from "./PrintDVHTermsConditions";



class PrintContract extends React.Component{


    render(){
        let data = this.props.rental
        return(
            <div>
                <div style={{breakAfter: "page"}}>
                    <PrintContractDetails rental={data}/>
                </div>
                <div style={{breakAfter: "page"}}>
                    <PrintContractDetails rental={data} customer_copy={true}/>
                </div>
                <div style={{breakAfter: "page"}}>
                    <PrintOffHireDetails rental={data}/>
                </div>
                {data.rental_type === "LT" &&
                    <div style={{breakAfter: "page"}}>
                        <PrintInsuranceDetails rental={data}/>
                    </div>
                }
                <div style={{breakAfter: "page"}}>
                    <PrintTermsAcknowledgement rental={data}/>
                </div>
            </div>
        )
    }
}

export default PrintContract;